import { TASKMANAGE } from 'Constants/ActionTypes';
const initialState = {
    height: 0,//详情抽屉的高度
    taskDetail: {
        show: false,//任务详情抽屉是否显示
        rowId: -1,//id
    },
    colors: ["#0190ff", "#59db98", "#ffa940", "#fc6c66", "#945bf7", "#37e1ee", "#ffc839", "#ff7297", "#bad440", "#3070ff", "#6f819f"],//交互详情echarts设定颜色
    echarts: null,//渲染echarts的dom
    tableListData: { //搜索列表
        data: [],
        total: 0,
    },
    searchData: { //搜索参数
        pageNum: 1,
        pageSize: 20,
        startMillis: 0,
        // endMillis: 1660121314925,
        endMillis: 0,
        // taskIds: [10282, 10279].join(","),
        taskIds: [].join(","),
    },
    pageStatus: { pageNum: 1, pageSize: 20 },
    showDetail: false,//是否展示交互详情
    detailCountList: [],//交互详情饼图数据
    detailListData: { //交互详情列表数据
        data: [],
        total: 0,
    },
    detailListParams: { //交互详情参数
        statisticId: null,
        pageNum: 1,
        pageSize: 10,
    }
}
export default (state = initialState, action) => {
    let { data, type } = action;
    switch (type) {
        case `${TASKMANAGE.GET_PAGE_LIST}_SUCCESS`:
            return {
                ...state,
                tableListData: {
                    data: action.payload.data.list || [],
                    total: action.payload.data.total || 0,
                },
            };
        case `${TASKMANAGE.SET_TASK_LIST_SEARCH_DATA}`:
            return {
                ...state,
                searchData: action.data,
            };
        case `${TASKMANAGE.SET_TASK_LIST_PAGE_STATUS}`:
            return {
                ...state,
                pageStatus: { ...state.pageStatus, ...action.data },
            };
        case `${TASKMANAGE.SET_STATE}`:
            return {
                ...state,
                [data.key]: data.value
            }
        case `${TASKMANAGE.GET_DETAIL_COUNT}_SUCCESS`:
            return {
                ...state,
                detailCountList: action.payload.data || []
            };
        case `${TASKMANAGE.GET_DETAIL_LIST}_SUCCESS`:
            return {
                ...state,
                detailListData: {
                    data: action.payload.data.list || [],
                    total: action.payload.data.total || 0,
                }
            };
        default:
            return state;
    }
}